"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _SelectionStepper = _interopRequireDefault(require("../SelectionStepper"));

var _passengerSelectionStepper = _interopRequireDefault(require("./passengerSelectionStepper.proptypes"));

var _passengerSelectionStepper2 = _interopRequireDefault(require("./passengerSelectionStepper.util"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var PassengerSelectionContainer = _styledComponents.default.div.withConfig({
  displayName: "PassengerSelectionStepper__PassengerSelectionContainer",
  componentId: "sc-1xnpl8p-0"
})(["display:flex;flex-direction:column;"]);

var PassengerSelectionStepper = function PassengerSelectionStepper(props) {
  var theme = props.theme,
      data = props.data,
      stepperClicked = props.stepperClicked,
      device = props.device,
      setPaxChild = props.setPaxChild,
      accessible = props.accessible,
      isShowChildAgeInput = props.isShowChildAgeInput,
      isShowInfantSelect = props.isShowInfantSelect;

  var _ref = data || {},
      adult = _ref.adult,
      child = _ref.child,
      infant = _ref.infant,
      passengerCount = _ref.passengerCount,
      stepperConfig = _ref.stepperConfig,
      passengerChildAge = _ref.passengerChildAge,
      ageList = _ref.ageList,
      placeholder = _ref.placeholder;

  var _useState = (0, _react.useState)(passengerCount),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      paxCount = _useState2[0],
      setPaxCount = _useState2[1];

  var _useState3 = (0, _react.useState)(passengerChildAge !== null && passengerChildAge !== void 0 ? passengerChildAge : null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      paxChildAge = _useState4[0],
      setPaxChildAge = _useState4[1];

  var changePaxCount = function changePaxCount(key) {
    return function (count) {
      stepperClicked(_objectSpread(_objectSpread({}, paxCount), {}, (0, _defineProperty2.default)({}, key, count)));
      setPaxCount(_objectSpread(_objectSpread({}, paxCount), {}, (0, _defineProperty2.default)({}, key, count)));
    };
  };

  var handlePaxChildAge = function handlePaxChildAge(pax) {
    if (isShowChildAgeInput) {
      setPaxChildAge(pax);
      setPaxChild(pax);
    }
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PassengerSelectionContainer, {
      theme: themeContext,
      id: "passenger-selection-stepper",
      tabIndex: tabIndex
    }, adult && /*#__PURE__*/_react.default.createElement(_SelectionStepper.default, {
      data: _objectSpread(_objectSpread({}, adult), {}, {
        min: _passengerSelectionStepper2.default.getMinPassengerCount(data, paxCount, adult.type),
        max: _passengerSelectionStepper2.default.getMaxPassengerCount(data, paxCount, adult.type),
        number: paxCount.adult
      }),
      onStepperClicked: changePaxCount(adult.type),
      stepperConfig: stepperConfig,
      "data-test": "selection-stepper-adult",
      theme: theme
    }), child && /*#__PURE__*/_react.default.createElement(_SelectionStepper.default, {
      data: _objectSpread(_objectSpread({}, child), {}, {
        min: _passengerSelectionStepper2.default.getMinPassengerCount(data, paxCount, child.type),
        max: _passengerSelectionStepper2.default.getMaxPassengerCount(data, paxCount, child.type),
        number: paxCount.child,
        childAge: paxChildAge,
        placeholder: placeholder,
        ageList: ageList
      }),
      device: device,
      isShowChildAgeInput: isShowChildAgeInput,
      setChildAge: handlePaxChildAge,
      onStepperClicked: changePaxCount(child.type),
      stepperConfig: stepperConfig,
      "data-test": "selection-stepper-child",
      theme: theme
    }), infant && isShowInfantSelect && /*#__PURE__*/_react.default.createElement(_SelectionStepper.default, {
      data: _objectSpread(_objectSpread({}, infant), {}, {
        min: _passengerSelectionStepper2.default.getMinPassengerCount(data, paxCount, infant.type),
        max: _passengerSelectionStepper2.default.getMaxPassengerCount(data, paxCount, infant.type),
        number: paxCount.infant
      }),
      onStepperClicked: changePaxCount(infant.type),
      stepperConfig: stepperConfig,
      "data-test": "selection-stepper-infant",
      theme: theme
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PassengerSelectionStepper.propTypes = _passengerSelectionStepper.default.PropTypes;
PassengerSelectionStepper.defaultProps = _passengerSelectionStepper.default.DefaultProps;
var _default = PassengerSelectionStepper;
exports.default = _default;